import { FadeUp } from "./Reveal";

const NAMES = [
  "Billboard Music Awards",
  "NBA",
  "NFL",
  "Dance World Competition",
  "The Next Step",
  "Live Nation",
  "Junos",
  "Disney",
  "Family Channel",
  "ACTRA",
];

export const TrustStrip = () => (
  <section className="relative py-16 lg:py-20 border-b border-white/10" data-testid="truststrip-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <FadeUp>
        <p className="eyebrow flex items-center justify-center gap-3">
          <span className="inline-block h-px w-10 bg-gold/60" aria-hidden="true" />
          Trusted By — Industry Experience
          <span className="inline-block h-px w-10 bg-gold/60" aria-hidden="true" />
        </p>
      </FadeUp>
      <FadeUp delay={0.08}>
        <div className="mt-9 flex flex-wrap justify-center gap-3" data-testid="truststrip-badges">
          {NAMES.map((n) => (
            <span
              key={n}
              className="rounded-full border border-gold/30 bg-gold/5 px-5 py-2.5 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.18em] text-gold cursor-default transition-colors duration-300 hover:bg-gold hover:text-ink"
            >
              {n}
            </span>
          ))}
        </div>
      </FadeUp>
    </div>
  </section>
);
